module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "contact"
    }
  }, [_h('p', ["\n    Please feel free to reach out to me via the following address.\n  "]), " ", _h('p', {
    staticClass: "emad"
  }, [_h('b', ["\n      rommel\n    "]), " ", _h('br'), "\n    at\n    ", _h('br'), " ", _h('b', ["rommelsantor"]), "\n    dot\n    ", _h('b', ["com"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73e1d8f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 53
// module chunks = 1